<div class="col-sm">
  <p-selectButton [options]="tabOptions" [formControl]="tabControl" optionLabel="label" optionValue="value" />
  @if (tabControl.value === 0) {
    <p-panel [header]="'Planning' | translateWF: 'Planning'">
      <p-card>
        <form [formGroup]="planningForm">
          <div class="col">
            <div class="form-box">
              <label>
                {{ 'dyeingDetailCard.customerServicePromisedDate' | translateWF: 'Customer Service Promised Date' }}
              </label>
              <p-datepicker fluid formControlName="customerServicePromisedDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay" class="w-full" />
            </div>
            <div class="form-box">
              <label>
                {{ 'dyeingDetailCard.knittingEstimatedEndDate' | translateWF: 'Knitting Estimated End Date' }}
              </label>
              <p-datepicker fluid formControlName="knittingEstimatedEndDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay" class="w-full" />
            </div>
            <div class="form-box">
              <label>
                {{ 'dyeingDetailCard.dyeingEstimatedEndDate' | translateWF: 'Dyeing Estimated End Date' }}
              </label>
              <p-datepicker fluid formControlName="dyeingEstimatedEndDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay" class="w-full" />
            </div>
            <div class="form-box">
              <label>
                {{ 'dyeingDetailCard.finishingEstimatedEndDate' | translateWF: 'Finishing Estimated End Date' }}
              </label>
              <p-datepicker fluid formControlName="finishingEstimatedEndDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay" class="w-full" />
            </div>
            <div class="form-box">
              <label>
                {{ 'dyeingDetailCard.actualFinishedDate' | translateWF: 'Actual Finished Date' }}
              </label>
              <p-datepicker fluid formControlName="actualFinishedDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay" class="w-full" />
            </div>
          </div>
        </form>
      </p-card>
    </p-panel>
  }
  @if (tabControl.value === 1) {
    @for (group of dyeingForecastSummary; track $index) {
      <p-panel [header]="group.color.name">
        <p-card data-variant="compact">
          <p-table [value]="group.fabrics" responsiveLayout="scroll">
            <ng-template #header>
              <tr class="primary__header text-sm">
                <th style="width: 30%">
                  {{ 'dyeingDetailCard.fabricCode' | translateWF: 'Fabric Code' }}
                </th>
                <th>
                  {{ 'dyeingDetailCard.needed' | translateWF: 'Needed' }}
                </th>
                <th>
                  {{ 'dyeingDetailCard.planned' | translateWF: 'Planned' }}
                </th>
                <th>
                  {{ 'dyeingDetailCard.remaining' | translateWF: 'Remaining' }}
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row>
              <tr>
                <td class="flex flex-col">
                  <p>
                    <b> ({{ row.fabricCode }}) </b>
                  </p>
                  <p class="text-sm">{{ row.fabric.longDescription }}</p>
                </td>
                <td>{{ row.quantityRequiredInUOM | number: '1.0-2' }}</td>
                <td>{{ row.quantityPlannedInUOM | number: '1.0-2' }}</td>
                <td>
                  {{ row.quantityRequiredInUOM - row.quantityPlannedInUOM | number: '1.0-2' }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr class="font-semibold border-t">
                <td>Total</td>
                <td>{{ geTotalNeeded(group) | number: '1.0-2' }} lbs</td>
                <td>{{ getTotalPlanning(group) | number: '1.0-2' }} lbs</td>
                <td>{{ getTotalRemaining(group) | number: '1.0-2' }} lbs</td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </p-panel>
    }
  }

  @if (tabControl.value === 2) {
    <p-panel header="Machine Information">
      <div class="col-xs">
        <p-panel data-tone="surface" header="Filter">
          <p-select
            [placeholder]="'dyeingDetailCard.portNumber' | translateWF: 'Port number'"
            [emptyFilterMessage]="'CommonMessages.notResult' | translateWF: 'No result Found'"
            [emptyMessage]="'CommonMessages.notResult' | translateWF: 'No Results Found'"
            class="w-full"
          />
        </p-panel>
        <p-panel data-tone="surface" header="Machine Available">
          <p-card data-variant="compact">
            <div class="col-sm">
              <p-panel *ngFor="let asset of assets" [header]="asset.assetId" [toggleable]="true" [collapsed]="true">
                <ng-template pTemplate="icons">
                  <p-tag [value]="'CommonMessages.Available' | translateWF: 'Available'" severity="success" rounded></p-tag>
                </ng-template>
                <p-card>
                  <ul class="col-sm" style="list-style: none">
                    <li class="px-2 row-between-center">
                      <strong> {{ 'dyeingDetailCard.machineType' | translateWF: 'Machine Type' }}: </strong>
                      <span>{{ asset.assetCategoryName || 'Dyeing Machine' }}</span>
                    </li>
                    <li class="p-2 row-between-center bg-gray-200 rounded-md">
                      <strong>
                        {{ 'dyeingDetailCard.numberOfPorts' | translateWF: 'Number of Ports' }}
                        :</strong
                      >
                      <span class="text-primary">{{ asset.dyeingMachineDetails?.numberOfPorts ?? 0 }}</span>
                    </li>
                    <li class="px-2 row-between-center"><strong>Kgs per Port:</strong><span class="text-primary">200 kg</span></li>
                    <li class="p-2 row-between-center bg-gray-200 rounded-md">
                      <strong>
                        {{ 'dyeingDetailCard.minCapacity' | translateWF: 'Min Capacity' }}
                        (60%):</strong
                      >
                      <span class="text-primary">{{ asset.assetCapacity?.minCapacity ?? 0 }} kg</span>
                    </li>
                    <li class="px-2 row-between-center">
                      <strong>
                        {{ 'dyeingDetailCard.maxCapacity' | translateWF: 'Max Capacity' }}
                        :</strong
                      >
                      <span class="text-primary">{{ asset.assetCapacity?.maxCapacity ?? 0 }} kg</span>
                    </li>
                  </ul>
                </p-card>
              </p-panel>
            </div>
          </p-card>
        </p-panel>
      </div>
    </p-panel>
  }
  @if (tabControl.value === 3) {
    <p-panel header="Information">
      <p-card>
        <div class="col">
          <div class="form-box">
            <label>
              {{ 'dyeingDetailCard.createdBy' | translateWF: 'Created By' }}
            </label>
            <input type="text" pInputText [disabled]="true" [ngModel]="workOrder.createdBy || '-'" class="w-full" />
          </div>

          <div class="form-box">
            <label>
              {{ 'dyeingDetailCard.createdDate' | translateWF: 'Created Date' }}
            </label>
            <p-datepicker fluid [iconDisplay]="'input'" [showIcon]="true" [disabled]="true" [ngModel]="workOrder.createdDate" inputId="createdDate" class="w-full" />
          </div>

          <div class="form-box">
            <label>
              {{ 'dyeingDetailCard.modifiedBy' | translateWF: 'Modified By' }}
            </label>
            <input type="text" pInputText [disabled]="true" [ngModel]="workOrder.modifiedBy || '-'" class="w-full" />
          </div>

          <div class="form-box">
            <label>
              {{ 'dyeingDetailCard.modifiedDate' | translateWF: 'Modified Date' }}
            </label>
            <p-datepicker fluid [iconDisplay]="'input'" [showIcon]="true" [disabled]="true" [ngModel]="workOrder.modifiedDate" inputId="modifiedDate" class="w-full" />
          </div>
        </div>
      </p-card>
    </p-panel>
  }
</div>
